import {Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, PipeTransform} from '@angular/core';
import {OptionTypes} from '../../../enums/optionTypes.enum';
import {generateRandomString} from '../../../utilities/string.utilities';

@Component({
    selector: 'app-options-list',
    templateUrl: './options-list.component.html',
    styleUrls: ['././options-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionsListComponent implements OnInit {
    @Input() options: object[];
    @Input() bindProperty: string;
    @Input() bindTextProperty: string;
    @Input() translate;
    @Input() selected: object[] = [];
    @Input() optionType: OptionTypes;
    @Input() pipes: PipeTransform[] = [];

    @Output() optionSelected: EventEmitter<object> = new EventEmitter();

    optionTypesEnum = OptionTypes;
    inputName: string = generateRandomString(16);
    isPrimary: boolean;

    constructor() {
    }

    ngOnChanges() {
        this.checkPrimary();
    }

    ngOnInit() {

    }

    onOptionSelected(index: number) {
        this.optionSelected.emit(this.options[index]);
    }

    isSelected(option: object) {
        return this.selected.find(s => s === option);
    }

    getOptionText(option: object) {
        if (this.isPrimary) {
            this.pipes.forEach(pipe => option = pipe.transform(option));

            return option;
        } else {
            option = Object.assign({}, option);

            this.pipes.forEach(pipe => option[this.bindProperty] = pipe.transform(option[this.bindProperty]));

            return option[this.bindProperty];
        }
    }

    getOptionBindText(option: object) {
        if (this.isPrimary) {
            this.pipes.forEach(pipe => option = pipe.transform(option));

            return option;
        } else {
            option = Object.assign({}, option);

            this.pipes.forEach(pipe => option[this.bindTextProperty] = pipe.transform(option[this.bindTextProperty]));

            return option[this.bindTextProperty];
        }
    }

    hasText(option: object) {
        if (this.isPrimary) {
            this.pipes.forEach(pipe => option = pipe.transform(option));

            return option !== null && typeof option[this.bindTextProperty] !== 'undefined';
        } else {
            option = Object.assign({}, option);

            this.pipes.forEach(pipe => option[this.bindTextProperty] = pipe.transform(option[this.bindTextProperty]));

            return option[this.bindTextProperty] !== null && typeof option[this.bindTextProperty] !== 'undefined';
        }
    }

    private checkPrimary() {
        if (this.options && this.options.length) {
            const first = this.options[0];

            if (typeof first !== 'object' && typeof first !== 'function') {
                this.isPrimary = true;
            } else {
                this.isPrimary = false;
            }
        }
    }
}
